module.exports = __webpack_public_path__ + "static/poster-5-288ab27d44e2188221b0b04d300279b3.jpg";